/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shopping_RestockedInputs */

const en_shopping_restocked = /** @type {(inputs: Shopping_RestockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} restocked`)
};

const de_shopping_restocked = /** @type {(inputs: Shopping_RestockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nachgekauft`)
};

/**
* | output |
* | --- |
* | "{name} restocked" |
*
* @param {Shopping_RestockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_restocked = /** @type {((inputs: Shopping_RestockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_RestockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_restocked(inputs)
	return en_shopping_restocked(inputs)
});